import { useEffect } from "react";

import { useFireAnalyticsEvents } from "@/components/fastshift/analytics";
import {
    ActionKey,
    ActionSubjectKey,
    ActionSubjectIdKey
} from "@/components/fastshift/analytics/constants";

import { RawRelationships } from "../types";

import { useRelationshipsAnalyticsData } from "./use-relationships-analytics-data";

export const useRelationshipsPageAnalytics = (
    relationships: RawRelationships
) => {
    const { sourceKey, identityAttrs } = useRelationshipsAnalyticsData();
    const { fireTrackEvent } = useFireAnalyticsEvents(identityAttrs);

    // Track event for relationships section displayed
    useEffect(() => {
        if (!identityAttrs) {
            return;
        }

        const fastshiftRelationships = relationships.map((r) => r.type);
        const hasCustomerFastshiftChampion = relationships.some(
            (r) => r.type === "FAST_SHIFT_CHAMPION"
        );

        fireTrackEvent({
            action: ActionKey.DISPLAYED,
            actionSubject: ActionSubjectKey.SECTION,
            actionSubjectId: ActionSubjectIdKey.FASTSHIFT_RELATIONSHIPS_SECTION,
            source: sourceKey,
            attributes: {
                hasCustomerFastshiftChampion,
                fastshiftRelationships
            }
        });
    }, [fireTrackEvent, identityAttrs, sourceKey, relationships]);
};
